import { render, staticRenderFns } from "./Payoneer.vue?vue&type=template&id=0adf4c45&scoped=true"
import script from "./Payoneer.vue?vue&type=script&lang=js"
export * from "./Payoneer.vue?vue&type=script&lang=js"
import style0 from "./Payoneer.vue?vue&type=style&index=0&id=0adf4c45&prod&scoped=true&lang=css"
import style1 from "./Payoneer.vue?vue&type=style&index=1&id=0adf4c45&prod&scoped=true&lang=scss"
import style2 from "./Payoneer.vue?vue&type=style&index=2&id=0adf4c45&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adf4c45",
  null
  
)

export default component.exports